module.exports = __webpack_public_path__ + "static/media/off-icon.903b4056.svg";